// Amazon's image CDN scales on request: a `._SL<px>_` modifier in front of the
// extension returns the picture with its longest side at <px>. The catalog
// hands the dashboard the full-size original (often 1500px and more), which
// the browser decodes in full (width × height × 4 bytes) just to draw a 50px
// thumbnail; across a store with thousands of products that alone runs into
// gigabytes.
const AMAZON_IMAGE_URL =
  /^(https?:\/\/[^/]*(?:media-amazon\.com|images-amazon\.com)\/images\/I\/[^/.]+)(\.(?:jpe?g|png|gif|webp))$/i;

/**
 * Thumbnail-sized variant of an Amazon product image URL. Anything that is not
 * a plain, unmodified Amazon image URL comes back untouched, so a caller can
 * always fall back to the original.
 */
export const productThumbnailUrl = (url, size = 120) => {
  if (typeof url !== "string") return url;
  const match = url.match(AMAZON_IMAGE_URL);
  return match ? `${match[1]}._SL${size}_${match[2]}` : url;
};
